// extracted by mini-css-extract-plugin
export var promo = "index-module--promo--hlGsS";
export var recent = "index-module--recent--z6LS7";
export var fadein = "index-module--fadein--+3pSa";